import { CUSTOMER_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

AxiosCurlirize(axios, () => {});

export interface IPersonaDetailsResponse {
  status: boolean;
  message: string;
  data: {
    user_id: string;
    persona_tags: Array<string>;
  } | null;
}

// GET the persona tags already stored against a client (iam_app_customer.persona_tags)
export const useUserPersonaDetailsAPI = () => {
  const [personaTags, setPersonaTags] = useState<Array<string>>([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (user_id: string) => {
      if (!user_id) {
        return;
      }
      setLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CUSTOMER_APIS?.PERSONA_DETAILS_API?.baseURL}${user_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPersonaDetailsResponse>) => {
            if (res.data.status === true) {
              setPersonaTags(res.data.data?.persona_tags ?? []);
            } else {
              setPersonaTags([]);
            }
            setFetched(true);
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setPersonaTags([]);
            setFetched(true);
            toast.error("Could not fetch existing personas.");
          });
      } catch (e: any) {
        setPersonaTags([]);
        setFetched(true);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, configuration],
  );

  return { execute, personaTags, loading, fetched };
};
